var items = {
  "block.minecraft.air": "ea",
  "block.minecraft.stone": "pōhaku",
  "block.minecraft.granite": "māpala",
  "block.minecraft.polished_granite": "pala hinu māpala",
  "block.minecraft.diorite": "keʻokeʻo pohaku",
  "block.minecraft.polished_diorite": "pala hinu keʻokeʻo pohaku",
  "block.minecraft.andesite": "hinahina pohaku",
  "block.minecraft.polished_andesite": "pala hinu hinahina pohaku",
  "block.minecraft.grass_block": "mauʻu",
  "block.minecraft.dirt": "lepo",
  "block.minecraft.coarse_dirt": "mānoanoa lepo",
  "block.minecraft.podzol": "laʻau lepo",
  "block.minecraft.crimson_nylium": "mea kūkaelio nether ʻulaʻula",
  "block.minecraft.warped_nylium": "mea kūkaelio nekele pupule",
  "block.minecraft.cobblestone": "nahā pohaku",
  "block.minecraft.oak_planks": "inapine",
  "block.minecraft.spruce_planks": "paina papa lāʻau",
  "block.minecraft.birch_planks": "keʻokeʻo papa lāʻau",
  "block.minecraft.jungle_planks": "wao nahele papa lāʻau",
  "block.minecraft.acacia_planks": "pouli ʻoke papa lāʻau",
  "block.minecraft.dark_oak_planks": "ʻeleʻele ʻoka papa lāʻau",
  "block.minecraft.crimson_planks": "papa lāʻau ʻulaʻula",
  "block.minecraft.warped_planks": "papa lāʻau pupule",
  "block.minecraft.oak_sapling": "ʻoke ʻuʻuku lāʻau",
  "block.minecraft.spruce_sapling": "paina ʻuʻuku lāʻau",
  "block.minecraft.birch_sapling": "keʻokeʻo ʻuʻuku lāʻau",
  "block.minecraft.jungle_sapling": "wao nahele ʻuʻuku lāʻau",
  "block.minecraft.acacia_sapling": "ʻakakiʻa ʻuʻuku lāʻau",
  "block.minecraft.dark_oak_sapling": "pouli ʻoke papa lāʻau",
  "block.minecraft.bedrock": "kūpapakū",
  "block.minecraft.sand": "one",
  "block.minecraft.red_sand": "ʻulaʻula one",
  "block.minecraft.gravel": "ʻiliʻili",
  "block.minecraft.gold_ore": "kula pohaku",
  "block.minecraft.iron_ore": "hao pohaku",
  "block.minecraft.coal_ore": "lānahu pohaku",
  "block.minecraft.nether_gold_ore": "ka ʻōhaʻi kula nekele",
  "block.minecraft.oak_log": "waeʻoka",
  "block.minecraft.spruce_log": "paina lāʻau moku",
  "block.minecraft.birch_log": "keʻokeʻo lāʻau moku",
  "block.minecraft.jungle_log": "wao nahele lāʻau moku",
  "block.minecraft.acacia_log": "ʻakakiʻa lāʻau moku",
  "block.minecraft.dark_oak_log": "pouli ʻoke lāʻau moku",
  "block.minecraft.crimson_stem": "hā ʻulaʻula",
  "block.minecraft.warped_stem": "hā pupule",
  "block.minecraft.stripped_oak_log": "pau kaʻoka log",
  "block.minecraft.stripped_spruce_log": "hoʻopuka i kahi mea kākau",
  "block.minecraft.stripped_birch_log": "kuhiʻiaʻo birch log",
  "block.minecraft.stripped_jungle_log": "hoʻopuka i kahi mea kākau",
  "block.minecraft.stripped_acacia_log": "kuhiʻiaʻo acacia log",
  "block.minecraft.stripped_dark_oak_log": "pau kaʻoka log",
  "block.minecraft.stripped_crimson_stem": "hā ʻulaʻula holehole",
  "block.minecraft.stripped_warped_stem": "hā pupule holehole",
  "block.minecraft.stripped_oak_wood": "pau kaʻoka log",
  "block.minecraft.stripped_spruce_wood": "hoʻopuka i kahi mea kākau",
  "block.minecraft.stripped_birch_wood": "kuhiʻiaʻo birch wood",
  "block.minecraft.stripped_jungle_wood": "hoʻopuka i kahi mea kākau",
  "block.minecraft.stripped_acacia_wood": "kuhiʻiaʻo acacia wood",
  "block.minecraft.stripped_dark_oak_wood": "pau kaʻoka log",
  "block.minecraft.stripped_crimson_hyphae": "awepaʻa ʻulaʻula holehole",
  "block.minecraft.stripped_warped_hyphae": "awepaʻa pupule holehole",
  "block.minecraft.oak_wood": "ʻoke lāʻau",
  "block.minecraft.spruce_wood": "paina lāʻau",
  "block.minecraft.birch_wood": "pūkowi lāʻau",
  "block.minecraft.jungle_wood": "wao nahele lāʻau",
  "block.minecraft.acacia_wood": "koa lāʻau",
  "block.minecraft.dark_oak_wood": "pouli ʻoke lāʻau",
  "block.minecraft.crimson_hyphae": "awepaʻa ʻulaʻula",
  "block.minecraft.warped_hyphae": "awepaʻa pupule",
  "block.minecraft.oak_leaves": "ʻoke lau",
  "block.minecraft.spruce_leaves": "paina lau",
  "block.minecraft.birch_leaves": "keʻokeʻo lau",
  "block.minecraft.jungle_leaves": "wao nahele lau",
  "block.minecraft.acacia_leaves": "ʻakakiʻa lau",
  "block.minecraft.dark_oak_leaves": "pouli ʻoke lau",
  "block.minecraft.sponge": "huʻahuʻakai",
  "block.minecraft.wet_sponge": "pulu huʻahuʻakai",
  "block.minecraft.glass": "aniani",
  "block.minecraft.lapis_ore": "polū pohaku",
  "block.minecraft.lapis_block": "polū palaka",
  "block.minecraft.dispenser": "pana palaka",
  "block.minecraft.sandstone": "kumuone",
  "block.minecraft.chiseled_sandstone": "kiʻi kālaiʻia kumuone",
  "block.minecraft.cut_sandstone": "ʻulaʻula kumuone",
  "block.minecraft.note_block": "pila hoʻokani palaka",
  "block.minecraft.powered_rail": "uila alahao",
  "block.minecraft.detector_rail": "mākaʻikiu alahao",
  "block.minecraft.sticky_piston": "pipili kuʻe",
  "block.minecraft.cobweb": "pūnāwelewele",
  "block.minecraft.grass": "mauʻu",
  "block.minecraft.fern": "kupukupu",
  "block.minecraft.dead_bush": "make ʻoʻoi",
  "block.minecraft.seagrass": "seagrass",
  "block.minecraft.sea_pickle": "ʻo ka sea pickle",
  "block.minecraft.piston": "kuʻe",
  "block.minecraft.white_wool": "ke'oke'o hulu hipa",
  "block.minecraft.orange_wool": "ʻālani hulu hipa",
  "block.minecraft.magenta_wool": "ʻākala poni hulu hipa",
  "block.minecraft.light_blue_wool": "malamalama polū hulu hipa",
  "block.minecraft.yellow_wool": "melemele hulu hipa",
  "block.minecraft.lime_wool": "malamalama ʻōmaʻomaʻo hulu hipa",
  "block.minecraft.pink_wool": "ʻākala hulu hipa",
  "block.minecraft.gray_wool": "hinahina hulu hipa",
  "block.minecraft.light_gray_wool": "malamalama hinahina hulu hipa",
  "block.minecraft.cyan_wool": "polū ʻōmaʻomaʻo hulu hipa",
  "block.minecraft.purple_wool": "poni hulu hipa",
  "block.minecraft.blue_wool": "polū hulu hipa",
  "block.minecraft.brown_wool": "palaʻunu hulu hipa",
  "block.minecraft.green_wool": "ʻōmaʻomaʻo hulu hipa",
  "block.minecraft.red_wool": "ʻulaʻula hulu hipa",
  "block.minecraft.black_wool": "ʻeleʻele hulu hipa",
  "block.minecraft.dandelion": "laulele",
  "block.minecraft.poppy": "pua kala",
  "block.minecraft.blue_orchid": "polū ʻokika",
  "block.minecraft.allium": "ʻakaʻakai",
  "block.minecraft.azure_bluet": "polū pua",
  "block.minecraft.red_tulip": "ʻulaʻula kulipa",
  "block.minecraft.orange_tulip": "ʻālani kulipa",
  "block.minecraft.white_tulip": "keʻokeʻo kulipa",
  "block.minecraft.pink_tulip": "lokelani kulipa",
  "block.minecraft.oxeye_daisy": "naʻenaʻe",
  "block.minecraft.cornflower": "kui",
  "block.minecraft.lily_of_the_valley": "lily o ke awāwa",
  "block.minecraft.wither_rose": "ina makadicmea ng",
  "block.minecraft.brown_mushroom": "ʻo kawa mushroom",
  "block.minecraft.red_mushroom": "hoʻokumuʻulaʻula",
  "block.minecraft.crimson_fungus": "kūkaelio ʻualʻula",
  "block.minecraft.warped_fungus": "kūkaelio pupule",
  "block.minecraft.crimson_roots": "aʻa ʻulaʻula",
  "block.minecraft.warped_roots": "aʻa pupule",
  "block.minecraft.nether_sprouts": "kupu nekele",
  "block.minecraft.weeping_vines": "kālī uē",
  "block.minecraft.twisting_vines": "kālī wili",
  "block.minecraft.sugar_cane": "ʻohe",
  "block.minecraft.kelp": "kelp",
  "block.minecraft.bamboo": "bamboo",
  "block.minecraft.gold_block": "kula palaka",
  "block.minecraft.iron_block": "hao palaka",
  "block.minecraft.oak_slab": "pākuʻiʻoka",
  "block.minecraft.spruce_slab": "paina lāʻau moku",
  "block.minecraft.birch_slab": "keʻokeʻo lāʻau moku",
  "block.minecraft.jungle_slab": "wao nahele lāʻau moku",
  "block.minecraft.acacia_slab": "ʻakakiʻa lāʻau moku",
  "block.minecraft.dark_oak_slab": "pouli ʻoke lāʻau moku",
  "block.minecraft.crimson_slab": "paukū pālālā ʻulaʻula",
  "block.minecraft.warped_slab": "paukū pālālā pupule",
  "block.minecraft.stone_slab": "pohaku paukū",
  "block.minecraft.smooth_stone_slab": "malino kumuone slab",
  "block.minecraft.sandstone_slab": "one pohaku paukū",
  "block.minecraft.cut_sandstone_slab": "eʻoki i ka pōhakuʻula ʻoʻala",
  "block.minecraft.petrified_oak_slab": "hoʻopiliʻiaʻo'oak kala",
  "block.minecraft.cobblestone_slab": "uʻuku pohaku paukū",
  "block.minecraft.brick_slab": "lepo paukū",
  "block.minecraft.stone_brick_slab": "pohaku lepo paukū",
  "block.minecraft.nether_brick_slab": "nether lepo paukū",
  "block.minecraft.quartz_slab": "pohaku aʻiaʻi paukū",
  "block.minecraft.red_sandstone_slab": "ʻulaʻula one pohaku paukū",
  "block.minecraft.cut_red_sandstone_slab": "ʻulaʻula one pohaku paukū",
  "block.minecraft.purpur_slab": "pulapula paukū",
  "block.minecraft.prismarine_slab": "pelikimalina pohaku",
  "block.minecraft.prismarine_brick_slab": "pelikimalina lepo",
  "block.minecraft.dark_prismarine_slab": "pouli pelikimalina",
  "block.minecraft.smooth_quartz": "palaka pōaka keʻo ʻōmolemole",
  "block.minecraft.smooth_red_sandstone": "malino ʻulaʻula kumuone",
  "block.minecraft.smooth_sandstone": "malino kumuone",
  "block.minecraft.smooth_stone": "malino kumuone",
  "block.minecraft.bricks": "lepo",
  "block.minecraft.tnt": "hoʻopahū",
  "block.minecraft.bookshelf": "pahu puke",
  "block.minecraft.mossy_cobblestone": "limu pā pohaku",
  "block.minecraft.obsidian": "ʻeleʻele pele",
  "block.minecraft.torch": "lama",
  "block.minecraft.end_rod": "enekela lama",
  "block.minecraft.chorus_plant": "hui kanu",
  "block.minecraft.chorus_flower": "hui pua",
  "block.minecraft.purpur_block": "pulapula palaka",
  "block.minecraft.purpur_pillar": "pulapula kūkulu",
  "block.minecraft.purpur_stairs": "pulapula anuʻu",
  "block.minecraft.spawner": "ana",
  "block.minecraft.oak_stairs": "ʻo ke ala kūiki",
  "block.minecraft.chest": "pahu",
  "block.minecraft.diamond_ore": "kaimana pohaku",
  "block.minecraft.diamond_block": "kaimana palaka",
  "block.minecraft.crafting_table": "papa hana",
  "block.minecraft.farmland": "kīhāpai",
  "block.minecraft.furnace": "umu",
  "block.minecraft.ladder": "alapiʻi",
  "block.minecraft.rail": "alahao",
  "block.minecraft.cobblestone_stairs": "uʻuku pohaku anuʻu",
  "block.minecraft.lever": "lōhai",
  "block.minecraft.stone_pressure_plate": "pale kūkulu pōhaku",
  "block.minecraft.oak_pressure_plate": "pale kūkulu pōhaku",
  "block.minecraft.spruce_pressure_plate": "pale kūkulu pōhaku",
  "block.minecraft.birch_pressure_plate": "pale kūkulu pōhaku",
  "block.minecraft.jungle_pressure_plate": "pale kūkulu pōhaku",
  "block.minecraft.acacia_pressure_plate": "pale kūkulu pōhaku",
  "block.minecraft.dark_oak_pressure_plate": "pale kūkulu pōhaku",
  "block.minecraft.crimson_pressure_plate": "pā mīkā ʻulaʻula",
  "block.minecraft.warped_pressure_plate": "pā mīkā pupule",
  "block.minecraft.polished_blackstone_pressure_plate": "pā mīkā pōhaku ʻeleʻele hinua",
  "block.minecraft.redstone_ore": "ka pulu uila",
  "block.minecraft.redstone_torch": "ke kukui uila",
  "block.minecraft.snow": "hau",
  "block.minecraft.ice": "hau",
  "block.minecraft.snow_block": "ka poʻa mele",
  "block.minecraft.cactus": "pānini",
  "block.minecraft.clay": "pālolo",
  "block.minecraft.jukebox": "mele palaka",
  "block.minecraft.oak_fence": "ʻoke pā lāʻau",
  "block.minecraft.spruce_fence": "paina pā lāʻau",
  "block.minecraft.birch_fence": "keʻokeʻo pā lāʻau",
  "block.minecraft.jungle_fence": "wao nahele pā lāʻau",
  "block.minecraft.acacia_fence": "ʻakakiʻa pā lāʻau",
  "block.minecraft.dark_oak_fence": "pouli ʻoke pā lāʻau",
  "block.minecraft.crimson_fence": "pā ʻulaʻula",
  "block.minecraft.warped_fence": "pā pupule",
  "block.minecraft.pumpkin": "palaʻai",
  "block.minecraft.carved_pumpkin": "paʻalu paʻupaʻa",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "uhane one",
  "block.minecraft.soul_soil": "ʻo ka lepo me nā ʻuhane",
  "block.minecraft.basalt": "pōhaku paʻa",
  "block.minecraft.polished_basalt": "pōhaku paʻa hinua",
  "block.minecraft.soul_torch": "paʻa makapu",
  "block.minecraft.glowstone": "glowstone",
  "block.minecraft.jack_o_lantern": "malamalama palaʻai",
  "block.minecraft.oak_trapdoor": "pākuʻi'oak",
  "block.minecraft.spruce_trapdoor": "ka spruce trapdoor",
  "block.minecraft.birch_trapdoor": "hao ʻūmiʻi puka",
  "block.minecraft.jungle_trapdoor": "wahi kū'ē",
  "block.minecraft.acacia_trapdoor": "paʻa acacia",
  "block.minecraft.dark_oak_trapdoor": "pākuʻi'oak",
  "block.minecraft.crimson_trapdoor": "puka ʻūmiʻi ʻulaʻula",
  "block.minecraft.warped_trapdoor": "puka ʻūmiʻi pupule",
  "block.minecraft.infested_stone": "ke pipi kūmole",
  "block.minecraft.infested_cobblestone": "ka pōhaku hoʻomoe pōhaku",
  "block.minecraft.infested_stone_bricks": "enekela pohaku lepo",
  "block.minecraft.infested_mossy_stone_bricks": "enekela pohaku lepo",
  "block.minecraft.infested_cracked_stone_bricks": "enekela pohaku lepo",
  "block.minecraft.infested_chiseled_stone_bricks": "enekela pohaku lepo",
  "block.minecraft.stone_bricks": "pohaku lepo",
  "block.minecraft.mossy_stone_bricks": "limu pohaku lepo",
  "block.minecraft.cracked_stone_bricks": "nahā pohaku lepo",
  "block.minecraft.chiseled_stone_bricks": "pohaku pao lepo",
  "block.minecraft.brown_mushroom_block": "ʻo brown mushroom poraka",
  "block.minecraft.red_mushroom_block": "ʻohana red mushroom",
  "block.minecraft.mushroom_stem": "kūkaileo kupa",
  "block.minecraft.iron_bars": "hao kī",
  "block.minecraft.chain": "kaulahao",
  "block.minecraft.glass_pane": "ʻāpana aniani",
  "block.minecraft.melon": "ipu",
  "block.minecraft.vine": "kolokolo",
  "block.minecraft.oak_fence_gate": "ʻoke pā puka lāʻau",
  "block.minecraft.spruce_fence_gate": "paina pā puka lāʻau",
  "block.minecraft.birch_fence_gate": "keʻokeʻo pā puka lāʻau",
  "block.minecraft.jungle_fence_gate": "wao nahele pā puka lāʻau",
  "block.minecraft.acacia_fence_gate": "ʻakakiʻa pā puka lāʻau",
  "block.minecraft.dark_oak_fence_gate": "pouli ʻoke pā puka lāʻau",
  "block.minecraft.crimson_fence_gate": "] pā ʻulaʻula",
  "block.minecraft.warped_fence_gate": "puka pā pupule",
  "block.minecraft.brick_stairs": "lepo anuʻu",
  "block.minecraft.stone_brick_stairs": "pohaku lepo anuʻu",
  "block.minecraft.mycelium": "kūkaileo mauʻu",
  "block.minecraft.lily_pad": "lilia-lana-i-ka-wai",
  "block.minecraft.nether_bricks": "nekele lepo",
  "block.minecraft.cracked_nether_bricks": "pōhaku lepo nekele i kīkē ʻia",
  "block.minecraft.chiseled_nether_bricks": "pōhaku lepo nekele i kila ʻia",
  "block.minecraft.nether_brick_fence": "nekele lepo pā",
  "block.minecraft.nether_brick_stairs": "nekele lepo anuʻu",
  "block.minecraft.enchanting_table": "hoʻokalakupua papa",
  "block.minecraft.end_portal_frame": "hoʻopau i ka hōʻailona portal",
  "block.minecraft.end_stone": "enekela pohaku",
  "block.minecraft.end_stone_bricks": "enekela pohaku lepo",
  "block.minecraft.dragon_egg": "moʻo hua",
  "block.minecraft.redstone_lamp": "ʻulaʻula pohaku malamalama",
  "block.minecraft.sandstone_stairs": "one pohaku anuʻu",
  "block.minecraft.emerald_ore": "ʻemelala pohaku",
  "block.minecraft.ender_chest": "enekela pahu",
  "block.minecraft.tripwire_hook": "kahi hookani",
  "block.minecraft.emerald_block": "ʻemelala palaka",
  "block.minecraft.spruce_stairs": "paina papa lāʻau anuʻu",
  "block.minecraft.birch_stairs": "lepo anuʻu",
  "block.minecraft.jungle_stairs": "wao nahele papa lāʻau anuʻu",
  "block.minecraft.crimson_stairs": "ʻanuʻu ʻulaʻula",
  "block.minecraft.warped_stairs": "ʻanuʻu pupule",
  "block.minecraft.command_block": "kauoha palaka",
  "block.minecraft.beacon": "lama kuhikuhi",
  "block.minecraft.cobblestone_wall": "nahā pā pohaku",
  "block.minecraft.mossy_cobblestone_wall": "limu pā pohaku",
  "block.minecraft.brick_wall": "ʻo brick wall",
  "block.minecraft.prismarine_wall": "prismarine wall",
  "block.minecraft.red_sandstone_wall": "ʻo ke kalaʻulaʻulaʻula",
  "block.minecraft.mossy_stone_brick_wall": "ʻo mossy stone brick wall",
  "block.minecraft.granite_wall": "ʻo granite wall",
  "block.minecraft.stone_brick_wall": "ʻo ka pōhaku pōhaku pōhaku",
  "block.minecraft.nether_brick_wall": "ka poʻe mele brick",
  "block.minecraft.andesite_wall": "ʻo ka andesite wall",
  "block.minecraft.red_nether_brick_wall": "ʻo red nether brick wall",
  "block.minecraft.sandstone_wall": "ʻo ka pōhaku sandstone",
  "block.minecraft.end_stone_brick_wall": "ʻo ka wall stone brick wall",
  "block.minecraft.diorite_wall": "ʻo diorite wall",
  "block.minecraft.blackstone_wall": "pā pōhaku ʻeleʻele",
  "block.minecraft.polished_blackstone_wall": "pā pōhaku ʻeleʻele hinua",
  "block.minecraft.polished_blackstone_brick_wall": "pā pōhaku ʻeleʻele hinua",
  "block.minecraft.stone_button": "kaomi pōhaku",
  "block.minecraft.oak_button": "pākuʻiʻoka",
  "block.minecraft.spruce_button": "ʻoihana pākuhi",
  "block.minecraft.birch_button": "'oiho pāhili",
  "block.minecraft.jungle_button": "ka pākiho mahu",
  "block.minecraft.acacia_button": "pākuʻi acacia",
  "block.minecraft.dark_oak_button": "ʻo ka'ōkuhiʻoka o ka pōʻeleʻele",
  "block.minecraft.crimson_button": "pihi ʻulaʻula",
  "block.minecraft.warped_button": "pihi pupule",
  "block.minecraft.polished_blackstone_button": "pihi pōhaku ʻeleʻele hinua",
  "block.minecraft.anvil": "kua",
  "block.minecraft.chipped_anvil": "kiʻi i ka pākū",
  "block.minecraft.damaged_anvil": "paʻeha haʻe",
  "block.minecraft.trapped_chest": "pahu ʻūmiʻi",
  "block.minecraft.light_weighted_pressure_plate": "plate palekana uila",
  "block.minecraft.heavy_weighted_pressure_plate": "plate palekana uila",
  "block.minecraft.daylight_detector": "kaʻike o ke ao",
  "block.minecraft.redstone_block": "ʻulaʻula pohaku palaka",
  "block.minecraft.nether_quartz_ore": "pohaku aʻiaʻi",
  "block.minecraft.hopper": "kānuku",
  "block.minecraft.chiseled_quartz_block": "pohaku aʻiaʻi pao palaka",
  "block.minecraft.quartz_block": "pohaku aʻiaʻi palaka",
  "block.minecraft.quartz_bricks": "pōhaku lepo pōaka keʻo",
  "block.minecraft.quartz_pillar": "ka pahu quartz",
  "block.minecraft.quartz_stairs": "pohaku aʻiaʻi anuʻu",
  "block.minecraft.activator_rail": "hoʻonā lawelawe",
  "block.minecraft.dropper": "hoʻi palaka",
  "block.minecraft.white_terracotta": "ʻo ka lepo'ōpiopio",
  "block.minecraft.orange_terracotta": "ʻo ka lepo'ōpiopio",
  "block.minecraft.magenta_terracotta": "ʻo ka lepo kāpili",
  "block.minecraft.light_blue_terracotta": "ʻo ka lepo'ōpiopio",
  "block.minecraft.yellow_terracotta": "ʻo ka lepo'ōpiopio",
  "block.minecraft.lime_terracotta": "ʻo ka lepo'ōpiopio",
  "block.minecraft.pink_terracotta": "ʻo ka lepo'ōpiopio",
  "block.minecraft.gray_terracotta": "ʻo ka lepo kāpili",
  "block.minecraft.light_gray_terracotta": "ʻo ka lepo'ōpiopio",
  "block.minecraft.cyan_terracotta": "ʻo ka lepo'ōpiopio",
  "block.minecraft.purple_terracotta": "poni palakō",
  "block.minecraft.blue_terracotta": "ʻo ka lepo'ōpiopio",
  "block.minecraft.brown_terracotta": "ʻo ka lepo kāpili",
  "block.minecraft.green_terracotta": "ʻo ka lepo kāpili",
  "block.minecraft.red_terracotta": "ʻo ka lepo kāpili",
  "block.minecraft.black_terracotta": "ʻo ka lepo'ōpiopio",
  "block.minecraft.barrier": "kaola",
  "block.minecraft.iron_trapdoor": "hao ʻūmiʻi puka",
  "block.minecraft.hay_block": "pela mauʻu maloʻo",
  "block.minecraft.white_carpet": "kea kape",
  "block.minecraft.orange_carpet": "ʻālani kāpeka",
  "block.minecraft.magenta_carpet": "ʻākala poni kāpeka",
  "block.minecraft.light_blue_carpet": "malamalama polū kāpeka",
  "block.minecraft.yellow_carpet": "melemele kāpeka",
  "block.minecraft.lime_carpet": "malamalama ʻōmaʻomaʻo kāpeka",
  "block.minecraft.pink_carpet": "ʻākala kāpeka",
  "block.minecraft.gray_carpet": "hinahina kāpeka",
  "block.minecraft.light_gray_carpet": "malamalama hinahina kāpeka",
  "block.minecraft.cyan_carpet": "polū ʻōmaʻomaʻo kāpeka",
  "block.minecraft.purple_carpet": "poni kāpeka",
  "block.minecraft.blue_carpet": "polū kāpeka",
  "block.minecraft.brown_carpet": "palaʻunu kāpeka",
  "block.minecraft.green_carpet": "ʻōmaʻomaʻo kāpeka",
  "block.minecraft.red_carpet": "ʻulaʻula kāpeka",
  "block.minecraft.black_carpet": "ʻeleʻele kāpeka",
  "block.minecraft.terracotta": "ʻo ka lepo kāpili",
  "block.minecraft.coal_block": "lānahu palaka",
  "block.minecraft.packed_ice": "hoʻokomo ʻia hau",
  "block.minecraft.acacia_stairs": "pouli ʻoke papa lāʻau anuʻu",
  "block.minecraft.dark_oak_stairs": "ʻeleʻele ʻoka papa lāʻau anuʻu",
  "block.minecraft.slime_block": "walewale palaka",
  "block.minecraft.grass_path": "mauʻu ala",
  "block.minecraft.sunflower": "pua nānā lā",
  "block.minecraft.lilac": "hueloʻīlio",
  "block.minecraft.rose_bush": "loke ʻoʻoi",
  "block.minecraft.peony": "peʻoni",
  "block.minecraft.tall_grass": "kahi kūlana",
  "block.minecraft.large_fern": "nui fern",
  "block.minecraft.white_stained_glass": "keʻokeʻo hoʻohaumiaʻo aniani",
  "block.minecraft.orange_stained_glass": "alani hoʻohaumiaʻo aniani",
  "block.minecraft.magenta_stained_glass": "ʻākala poni hoʻohaumiaʻo aniani",
  "block.minecraft.light_blue_stained_glass": "malamalama polū hoʻohaumiaʻo aniani",
  "block.minecraft.yellow_stained_glass": "melemele hoʻohaumiaʻo aniani",
  "block.minecraft.lime_stained_glass": "malamalama ʻōmaʻomaʻo hoʻohaumiaʻo aniani",
  "block.minecraft.pink_stained_glass": "ʻākala hoʻohaumiaʻo aniani",
  "block.minecraft.gray_stained_glass": "hinahina hoʻohaumiaʻo aniani",
  "block.minecraft.light_gray_stained_glass": "malamalama hinahina hoʻohaumiaʻo aniani",
  "block.minecraft.cyan_stained_glass": "polū ʻōmaʻomaʻo hoʻohaumiaʻo aniani",
  "block.minecraft.purple_stained_glass": "poni hoʻohaumiaʻo aniani",
  "block.minecraft.blue_stained_glass": "polū hoʻohaumiaʻo aniani",
  "block.minecraft.brown_stained_glass": "palaʻunu hoʻohaumiaʻo aniani",
  "block.minecraft.green_stained_glass": "ʻōmaʻomaʻo hoʻohaumiaʻo aniani",
  "block.minecraft.red_stained_glass": "ʻulaʻula hoʻohaumiaʻo aniani",
  "block.minecraft.black_stained_glass": "ʻeleʻele hoʻohaumiaʻo aniani",
  "block.minecraft.white_stained_glass_pane": "keʻokeʻo hoʻohaumiaʻo ʻāpana aniani",
  "block.minecraft.orange_stained_glass_pane": "alani hoʻohaumiaʻo ʻāpana aniani",
  "block.minecraft.magenta_stained_glass_pane": "ʻākala poni hoʻohaumiaʻo ʻāpana aniani",
  "block.minecraft.light_blue_stained_glass_pane": "malamalama polū hoʻohaumiaʻo ʻāpana aniani",
  "block.minecraft.yellow_stained_glass_pane": "melemele hoʻohaumiaʻo ʻāpana aniani",
  "block.minecraft.lime_stained_glass_pane": "malamalama ʻōmaʻomaʻo hoʻohaumiaʻo ʻāpana aniani",
  "block.minecraft.pink_stained_glass_pane": "ʻākala hoʻohaumiaʻo ʻāpana aniani",
  "block.minecraft.gray_stained_glass_pane": "hinahina hoʻohaumiaʻo ʻāpana aniani",
  "block.minecraft.light_gray_stained_glass_pane": "malamalama hinahina hoʻohaumiaʻo ʻāpana aniani",
  "block.minecraft.cyan_stained_glass_pane": "polū ʻōmaʻomaʻo hoʻohaumiaʻo ʻāpana aniani",
  "block.minecraft.purple_stained_glass_pane": "poni hoʻohaumiaʻo ʻāpana aniani",
  "block.minecraft.blue_stained_glass_pane": "polū hoʻohaumiaʻo ʻāpana aniani",
  "block.minecraft.brown_stained_glass_pane": "palaʻunu hoʻohaumiaʻo ʻāpana aniani",
  "block.minecraft.green_stained_glass_pane": "ʻōmaʻomaʻo hoʻohaumiaʻo ʻāpana aniani",
  "block.minecraft.red_stained_glass_pane": "ʻulaʻula hoʻohaumiaʻo ʻāpana aniani",
  "block.minecraft.black_stained_glass_pane": "ʻeleʻele hoʻohaumiaʻo ʻāpana aniani",
  "block.minecraft.prismarine": "pelikimalina",
  "block.minecraft.prismarine_bricks": "pelikimalina lepo",
  "block.minecraft.dark_prismarine": "pouli pelikimalina",
  "block.minecraft.prismarine_stairs": "pelikimalina pohaku",
  "block.minecraft.prismarine_brick_stairs": "pelikimalina lepo",
  "block.minecraft.dark_prismarine_stairs": "pouli pelikimalina",
  "block.minecraft.sea_lantern": "kai lama",
  "block.minecraft.red_sandstone": "ʻulaʻula kumuone",
  "block.minecraft.chiseled_red_sandstone": "kiʻi kālaiʻia ʻulaʻula kumuone",
  "block.minecraft.cut_red_sandstone": "eʻoki i ka pōhakuʻula ʻoʻala",
  "block.minecraft.red_sandstone_stairs": "ʻulaʻula one pohaku anuʻu",
  "block.minecraft.repeating_command_block": "hana hou kauoha palaka",
  "block.minecraft.chain_command_block": "kaula kauoha palaka",
  "block.minecraft.magma_block": "pele palaka",
  "block.minecraft.nether_wart_block": "nekele ʻilikona palaka",
  "block.minecraft.warped_wart_block": "nekele ʻilikona palaka",
  "block.minecraft.red_nether_bricks": "ʻulaʻula nekele lepo",
  "block.minecraft.bone_block": "iwi palaka",
  "block.minecraft.structure_void": "hakahaka palaka",
  "block.minecraft.observer": "ka mea nānā",
  "block.minecraft.shulker_box": "kāleka shulker",
  "block.minecraft.white_shulker_box": "kea ka pahu shulker",
  "block.minecraft.orange_shulker_box": "kea ka pahu shulker",
  "block.minecraft.magenta_shulker_box": "kea ka pahu shulker",
  "block.minecraft.light_blue_shulker_box": "kea ka pahu shulker",
  "block.minecraft.yellow_shulker_box": "kea ka pahu shulker",
  "block.minecraft.lime_shulker_box": "kea ka pahu shulker",
  "block.minecraft.pink_shulker_box": "kea ka pahu shulker",
  "block.minecraft.gray_shulker_box": "kea ka pahu shulker",
  "block.minecraft.light_gray_shulker_box": "kea ka pahu shulker",
  "block.minecraft.cyan_shulker_box": "kea ka pahu shulker",
  "block.minecraft.purple_shulker_box": "kea ka pahu shulker",
  "block.minecraft.blue_shulker_box": "kea ka pahu shulker",
  "block.minecraft.brown_shulker_box": "kea ka pahu shulker",
  "block.minecraft.green_shulker_box": "kea ka pahu shulker",
  "block.minecraft.red_shulker_box": "kea ka pahu shulker",
  "block.minecraft.black_shulker_box": "kea ka pahu shulker",
  "block.minecraft.white_glazed_terracotta": "ʻo ka lepo kāpili",
  "block.minecraft.orange_glazed_terracotta": "ʻo ka lepo kāpili",
  "block.minecraft.magenta_glazed_terracotta": "ʻo ka lepo kāpili",
  "block.minecraft.light_blue_glazed_terracotta": "ʻo ka lepo'ōpiopio",
  "block.minecraft.yellow_glazed_terracotta": "ʻo ka lepo kāpili",
  "block.minecraft.lime_glazed_terracotta": "ʻo ka lepo kāpili",
  "block.minecraft.pink_glazed_terracotta": "ʻo ka lepo kāpili",
  "block.minecraft.gray_glazed_terracotta": "ʻo ka lepo kāpili",
  "block.minecraft.light_gray_glazed_terracotta": "ʻo ka lepo'ōpiopio",
  "block.minecraft.cyan_glazed_terracotta": "ʻo ka lepo kāpili",
  "block.minecraft.purple_glazed_terracotta": "ʻo ka lepo kāpili",
  "block.minecraft.blue_glazed_terracotta": "ʻo ka lepo kāpili",
  "block.minecraft.brown_glazed_terracotta": "ʻo ka lepo kāpili",
  "block.minecraft.green_glazed_terracotta": "ʻo ka lepo kāpili",
  "block.minecraft.red_glazed_terracotta": "ʻo ka lepo kāpili",
  "block.minecraft.black_glazed_terracotta": "ʻo ka lepo kāpili",
  "block.minecraft.white_concrete": "maloawa tolpal",
  "block.minecraft.orange_concrete": "ineinaawa tolpal",
  "block.minecraft.magenta_concrete": "maikaʻi palohaawa tolpal",
  "block.minecraft.light_blue_concrete": "malamalama hinahina kāpeka",
  "block.minecraft.yellow_concrete": "alanawa tolpal",
  "block.minecraft.lime_concrete": "jam awa tolpal",
  "block.minecraft.pink_concrete": "s awa tolpal",
  "block.minecraft.gray_concrete": "au awa tolpal",
  "block.minecraft.light_gray_concrete": "malamalama hinahina kāpeka",
  "block.minecraft.cyan_concrete": "omaloawa tolpal",
  "block.minecraft.purple_concrete": "cafeukiohaawa tolpal",
  "block.minecraft.blue_concrete": "n awa tolpal",
  "block.minecraft.brown_concrete": "wu awa tolpal",
  "block.minecraft.green_concrete": "sheawa tolpal",
  "block.minecraft.red_concrete": "hele ope",
  "block.minecraft.black_concrete": "cafeawa tolpal",
  "block.minecraft.white_concrete_powder": "malamalama hinahina kāpeka",
  "block.minecraft.orange_concrete_powder": "malamalama hinahina kāpeka",
  "block.minecraft.magenta_concrete_powder": "malamalama hinahina kāpeka",
  "block.minecraft.light_blue_concrete_powder": "malamalama hinahina kāpeka",
  "block.minecraft.yellow_concrete_powder": "malamalama hinahina kāpeka",
  "block.minecraft.lime_concrete_powder": "malamalama hinahina kāpeka",
  "block.minecraft.pink_concrete_powder": "malamalama hinahina kāpeka",
  "block.minecraft.gray_concrete_powder": "malamalama hinahina kāpeka",
  "block.minecraft.light_gray_concrete_powder": "malamalama hinahina kāpeka",
  "block.minecraft.cyan_concrete_powder": "malamalama hinahina kāpeka",
  "block.minecraft.purple_concrete_powder": "malamalama hinahina kāpeka",
  "block.minecraft.blue_concrete_powder": "malamalama hinahina kāpeka",
  "block.minecraft.brown_concrete_powder": "malamalama hinahina kāpeka",
  "block.minecraft.green_concrete_powder": "malamalama hinahina kāpeka",
  "block.minecraft.red_concrete_powder": "malamalama hinahina kāpeka",
  "block.minecraft.black_concrete_powder": "malamalama hinahina kāpeka",
  "block.minecraft.turtle_egg": "ka'ōlaʻula",
  "block.minecraft.dead_tube_coral_block": "ʻo ke kino wailuaʻoi",
  "block.minecraft.dead_brain_coral_block": "ʻo ke kino wailuaʻoi",
  "block.minecraft.dead_bubble_coral_block": "ʻo ke kino wailuaʻoi",
  "block.minecraft.dead_fire_coral_block": "ʻo ke kino wailuaʻoi",
  "block.minecraft.dead_horn_coral_block": "ʻo ke kino wailuaʻoi",
  "block.minecraft.tube_coral_block": "ʻo ke kino wailuaʻoi",
  "block.minecraft.brain_coral_block": "ʻo ke kino wailuaʻoi",
  "block.minecraft.bubble_coral_block": "ʻo ke kino wailuaʻoi",
  "block.minecraft.fire_coral_block": "ʻo ke kino wailuaʻoi",
  "block.minecraft.horn_coral_block": "ʻo ke kino wailuaʻoi",
  "block.minecraft.tube_coral": "ʻo coral",
  "block.minecraft.brain_coral": "kole niho",
  "block.minecraft.bubble_coral": "ʻo coral",
  "block.minecraft.fire_coral": "ʻo coral",
  "block.minecraft.horn_coral": "ʻo coral",
  "block.minecraft.dead_brain_coral": "ʻo ke kino wailuaʻoi",
  "block.minecraft.dead_bubble_coral": "ʻo ke kino wailuaʻoi",
  "block.minecraft.dead_fire_coral": "ʻo ke kino wailuaʻoi",
  "block.minecraft.dead_horn_coral": "ʻo ke kino wailuaʻoi",
  "block.minecraft.dead_tube_coral": "ʻo ke kino wailuaʻoi",
  "block.minecraft.tube_coral_fan": "ʻo coral",
  "block.minecraft.brain_coral_fan": "kole niho",
  "block.minecraft.bubble_coral_fan": "ʻo coral",
  "block.minecraft.fire_coral_fan": "ʻo coral",
  "block.minecraft.horn_coral_fan": "kukui pākuʻu kōpana",
  "block.minecraft.dead_tube_coral_fan": "ʻo ke kino wailuaʻoi",
  "block.minecraft.dead_brain_coral_fan": "ʻo ke kino wailuaʻoi",
  "block.minecraft.dead_bubble_coral_fan": "ʻo ke kino wailuaʻoi",
  "block.minecraft.dead_fire_coral_fan": "ʻo ke kino wailuaʻoi",
  "block.minecraft.dead_horn_coral_fan": "ʻo ke kino wailuaʻoi",
  "block.minecraft.blue_ice": "ka hau polū",
  "block.minecraft.conduit": "kāhea",
  "block.minecraft.polished_granite_stairs": "hoʻokumuʻiaʻo granite stairs",
  "block.minecraft.smooth_red_sandstone_stairs": "malino ʻulaʻula kumuone",
  "block.minecraft.mossy_stone_brick_stairs": "ʻo mossy stone brick stairs",
  "block.minecraft.polished_diorite_stairs": "hoʻokumuʻiaʻo diorite stairs",
  "block.minecraft.mossy_cobblestone_stairs": "limu pā pohaku",
  "block.minecraft.end_stone_brick_stairs": "pohaku lepo anuʻu",
  "block.minecraft.stone_stairs": "one pohaku anuʻu",
  "block.minecraft.smooth_sandstone_stairs": "malino ʻulaʻula kumuone",
  "block.minecraft.smooth_quartz_stairs": "palaka pōaka keʻo ʻōmolemole",
  "block.minecraft.granite_stairs": "ʻo diorite kala",
  "block.minecraft.andesite_stairs": "ʻo'asepa",
  "block.minecraft.red_nether_brick_stairs": "nekele lepo anuʻu",
  "block.minecraft.polished_andesite_stairs": "hoʻokumuʻiaʻo andesite slab",
  "block.minecraft.diorite_stairs": "ʻo diorite kala",
  "block.minecraft.polished_granite_slab": "hoʻokumuʻiaʻo andesite slab",
  "block.minecraft.smooth_red_sandstone_slab": "malino ʻulaʻula kumuone",
  "block.minecraft.mossy_stone_brick_slab": "ʻo mossy stone brick wall",
  "block.minecraft.polished_diorite_slab": "hoʻokumuʻiaʻo andesite slab",
  "block.minecraft.mossy_cobblestone_slab": "limu pā pohaku",
  "block.minecraft.end_stone_brick_slab": "pohaku lepo paukū",
  "block.minecraft.smooth_sandstone_slab": "malino ʻulaʻula kumuone",
  "block.minecraft.smooth_quartz_slab": "palaka pōaka keʻo ʻōmolemole",
  "block.minecraft.granite_slab": "ʻo diorite kala",
  "block.minecraft.andesite_slab": "ʻo'asepa",
  "block.minecraft.red_nether_brick_slab": "ʻo red nether brick slab",
  "block.minecraft.polished_andesite_slab": "hoʻokumuʻiaʻo andesite slab",
  "block.minecraft.diorite_slab": "ʻo diorite kala",
  "block.minecraft.scaffolding": "huina“ʻāpala",
  "block.minecraft.iron_door": "hao puka",
  "block.minecraft.oak_door": "ʻoke lāʻau puka",
  "block.minecraft.spruce_door": "paina lāʻau puka",
  "block.minecraft.birch_door": "keʻokeʻo lāʻau puka",
  "block.minecraft.jungle_door": "wao nahele lāʻau puka",
  "block.minecraft.acacia_door": "ʻakakiʻa lāʻau puka",
  "block.minecraft.dark_oak_door": "pouli ʻoke lāʻau puka",
  "block.minecraft.crimson_door": "puka ʻulaʻula",
  "block.minecraft.warped_door": "puka pupule",
  "block.minecraft.repeater": "ʻulaʻula pohaku hana hou",
  "block.minecraft.comparator": "ʻulaʻula pohaku komapalakola",
  "block.minecraft.structure_block": "hale palaka",
  "block.minecraft.jigsaw": "palaka o nane",
  "item.minecraft.turtle_helmet": "pūpū manu kuhukukū□□ke poʻo:□+2 armor",
  "item.minecraft.scute": "kūleʻa",
  "item.minecraft.iron_shovel": "hao kopalā□□ke paʻa lima:□+3.5 attack damage□-3 attack speed",
  "item.minecraft.iron_pickaxe": "hao kipikua□□ke paʻa lima:□+3 attack damage□-2.8 attack speed",
  "item.minecraft.iron_axe": "hao koʻi□□ke paʻa lima:□+8 attack damage□-3.1 attack speed",
  "item.minecraft.flint_and_steel": "pohaku paea, a me kila",
  "item.minecraft.apple": "ʻāpala",
  "item.minecraft.bow": "pana",
  "item.minecraft.arrow": "pua pana",
  "item.minecraft.coal": "lānahu",
  "item.minecraft.charcoal": "lāʻau lānahu",
  "item.minecraft.diamond": "kaimana",
  "item.minecraft.iron_ingot": "hao lepo",
  "item.minecraft.gold_ingot": "kula lepo",
  "item.minecraft.netherite_ingot": "mahele mekalanekele",
  "item.minecraft.netherite_scrap": "huna mekalanekele",
  "item.minecraft.iron_sword": "hao pahi kaua□□ke paʻa lima:□+5 attack damage□-2.4 attack speed",
  "item.minecraft.wooden_sword": "lāʻau pahi kaua□□ke paʻa lima:□+3 attack damage□-2.4 attack speed",
  "item.minecraft.wooden_shovel": "lāʻau kopalā□□ke paʻa lima:□+1.5 attack damage□-3 attack speed",
  "item.minecraft.wooden_pickaxe": "lāʻau kipikua□□ke paʻa lima:□+1 attack damage□-2.8 attack speed",
  "item.minecraft.wooden_axe": "lāʻau koʻi□□ke paʻa lima:□+6 attack damage□-3.2 attack speed",
  "item.minecraft.stone_sword": "pohaku pahi kaua□□ke paʻa lima:□+4 attack damage□-2.4 attack speed",
  "item.minecraft.stone_shovel": "pohaku kopalā□□ke paʻa lima:□+2.5 attack damage□-3 attack speed",
  "item.minecraft.stone_pickaxe": "pohaku kipikua□□ke paʻa lima:□+2 attack damage□-2.8 attack speed",
  "item.minecraft.stone_axe": "pohaku koʻi□□ke paʻa lima:□+8 attack damage□-3.2 attack speed",
  "item.minecraft.diamond_sword": "kaimana pahi kaua□□ke paʻa lima:□+6 attack damage□-2.4 attack speed",
  "item.minecraft.diamond_shovel": "kaimana kopalā□□ke paʻa lima:□+4.5 attack damage□-3 attack speed",
  "item.minecraft.diamond_pickaxe": "kaimana kipikua□□ke paʻa lima:□+4 attack damage□-2.8 attack speed",
  "item.minecraft.diamond_axe": "kaimana koʻi□□ke paʻa lima:□+8 attack damage□-3 attack speed",
  "item.minecraft.stick": "koʻokoʻo",
  "item.minecraft.bowl": "pola",
  "item.minecraft.mushroom_stew": "kūkaileo kupa",
  "item.minecraft.golden_sword": "kula pahi kaua□□ke paʻa lima:□+3 attack damage□-2.4 attack speed",
  "item.minecraft.golden_shovel": "kula kopalā□□ke paʻa lima:□+1.5 attack damage□-3 attack speed",
  "item.minecraft.golden_pickaxe": "kula kipikua□□ke paʻa lima:□+1 attack damage□-2.8 attack speed",
  "item.minecraft.golden_axe": "kula koʻi□□ke paʻa lima:□+6 attack damage□-3 attack speed",
  "item.minecraft.netherite_sword": "pahikaua mekalanekele□□ke paʻa lima:□+7 attack damage□-2.4 attack speed",
  "item.minecraft.netherite_shovel": "kopalā mekalanekele□□ke paʻa lima:□+5.5 attack damage□-3 attack speed",
  "item.minecraft.netherite_pickaxe": "kipikua mekalanekele□□ke paʻa lima:□+5 attack damage□-2.8 attack speed",
  "item.minecraft.netherite_axe": "koʻi mekalanekele□□ke paʻa lima:□+9 attack damage□-3 attack speed",
  "item.minecraft.string": "kaula",
  "item.minecraft.feather": "hulu",
  "item.minecraft.gunpowder": "pauka kī pū",
  "item.minecraft.wooden_hoe": "lāʻau kālai□□ke paʻa lima:□-3 attack speed",
  "item.minecraft.stone_hoe": "pohaku kālai□□ke paʻa lima:□-2 attack speed",
  "item.minecraft.iron_hoe": "hao kālai□□ke paʻa lima:□-1 attack speed",
  "item.minecraft.diamond_hoe": "kaimana kālai□□ke paʻa lima:",
  "item.minecraft.golden_hoe": "kula kālai□□ke paʻa lima:□-3 attack speed",
  "item.minecraft.netherite_hoe": "hō mekalanekele□□ke paʻa lima:",
  "item.minecraft.wheat_seeds": "nā huapalaoa",
  "item.minecraft.wheat": "huika",
  "item.minecraft.bread": "palaoa",
  "item.minecraft.leather_helmet": "ʻili holoholona pāpale□□ke poʻo:□+1 armor",
  "item.minecraft.leather_chestplate": "ʻili holoholona lakeke□□ke kino:□+3 armor",
  "item.minecraft.leather_leggings": "ʻili holoholona lole wāwae□□ke hele ma nā wāwae:□+2 armor",
  "item.minecraft.leather_boots": "ʻili holoholona puki□□ke hele wāwae:□+1 armor",
  "item.minecraft.chainmail_helmet": "kaula mahiole□□ke poʻo:□+2 armor",
  "item.minecraft.chainmail_chestplate": "kaula pale umauma□□ke kino:□+5 armor",
  "item.minecraft.chainmail_leggings": "kaula lole wāwae□□ke hele ma nā wāwae:□+4 armor",
  "item.minecraft.chainmail_boots": "kaula puki□□ke hele wāwae:□+1 armor",
  "item.minecraft.iron_helmet": "hao mahiole□□ke poʻo:□+2 armor",
  "item.minecraft.iron_chestplate": "hao pale umauma□□ke kino:□+6 armor",
  "item.minecraft.iron_leggings": "hao lole wāwae□□ke hele ma nā wāwae:□+5 armor",
  "item.minecraft.iron_boots": "hao puki□□ke hele wāwae:□+2 armor",
  "item.minecraft.diamond_helmet": "kaimana mahiole□□ke poʻo:□+3 armor□+2 armor toughness",
  "item.minecraft.diamond_chestplate": "kaimana pale umauma□□ke kino:□+8 armor□+2 armor toughness",
  "item.minecraft.diamond_leggings": "kaimana lole wāwae□□ke hele ma nā wāwae:□+6 armor□+2 armor toughness",
  "item.minecraft.diamond_boots": "kaimana puki□□ke hele wāwae:□+3 armor□+2 armor toughness",
  "item.minecraft.golden_helmet": "kula mahiole□□ke poʻo:□+2 armor",
  "item.minecraft.golden_chestplate": "kula pale umauma□□ke kino:□+5 armor",
  "item.minecraft.golden_leggings": "kula lole wāwae□□ke hele ma nā wāwae:□+3 armor",
  "item.minecraft.golden_boots": "kula holoholona puki□□ke hele wāwae:□+1 armor",
  "item.minecraft.netherite_helmet": "mahiole mekalanekele□□ke poʻo:□+3 armor□+3 armor toughness□+1 knockback resistance",
  "item.minecraft.netherite_chestplate": "pale umauma mekalanekele□□ke kino:□+8 armor□+3 armor toughness□+1 knockback resistance",
  "item.minecraft.netherite_leggings": "lole wāwae mekalanekele□□ke hele ma nā wāwae:□+6 armor□+3 armor toughness□+1 knockback resistance",
  "item.minecraft.netherite_boots": "puki mekalanekele□□ke hele wāwae:□+3 armor□+3 armor toughness□+1 knockback resistance",
  "item.minecraft.flint": "pohaku paea",
  "item.minecraft.porkchop": "ʻiʻo puaʻa maka",
  "item.minecraft.cooked_porkchop": "ʻiʻo puaʻa moʻa",
  "item.minecraft.painting": "pena",
  "item.minecraft.golden_apple": "kula ʻāpala",
  "item.minecraft.enchanted_golden_apple": "ʻo apple apple",
  "block.minecraft.oak_sign": "inaiʻlimapine",
  "block.minecraft.spruce_sign": "paina lāʻau moku",
  "block.minecraft.birch_sign": "keʻokeʻo lāʻau moku",
  "block.minecraft.jungle_sign": "wao nahele lāʻau moku",
  "block.minecraft.acacia_sign": "ʻakakiʻa lāʻau moku",
  "block.minecraft.dark_oak_sign": "pouli ʻoke lāʻau moku",
  "block.minecraft.crimson_sign": "hōʻailona ʻulaʻula",
  "block.minecraft.warped_sign": "hōʻailona pupule",
  "item.minecraft.bucket": "pākeke",
  "item.minecraft.water_bucket": "wai pākeke",
  "item.minecraft.lava_bucket": "pele pākeke",
  "item.minecraft.minecart": "kaʻa huila la",
  "item.minecraft.saddle": "noho lio",
  "item.minecraft.redstone": "ke kapaʻeleʻele",
  "item.minecraft.snowball": "pōpōhau",
  "item.minecraft.oak_boat": "ʻoke lāʻau moku",
  "item.minecraft.leather": "ʻili holoholona",
  "item.minecraft.milk_bucket": "pākī milk",
  "item.minecraft.pufferfish_bucket": "pākeke o pufferfish",
  "item.minecraft.salmon_bucket": "pākeke o salemona",
  "item.minecraft.cod_bucket": "pākeke o cod",
  "item.minecraft.tropical_fish_bucket": "pākeke iʻa tropical",
  "item.minecraft.brick": "lepo",
  "item.minecraft.clay_ball": "kinipōpō pālolo",
  "block.minecraft.dried_kelp_block": "piʻi kelp poraka",
  "item.minecraft.paper": "pepa",
  "item.minecraft.book": "buke",
  "item.minecraft.slime_ball": "pōpōwalewale",
  "item.minecraft.chest_minecart": "nā kāleka me chest",
  "item.minecraft.furnace_minecart": "minecart me ka umu ahi",
  "item.minecraft.egg": "hua",
  "item.minecraft.compass": "pānānā",
  "item.minecraft.fishing_rod": "mākoi",
  "item.minecraft.clock": "uaki",
  "item.minecraft.glowstone_dust": "ke kapaʻeleʻele",
  "item.minecraft.cod": "cod maka",
  "item.minecraft.salmon": "maka kāmano",
  "item.minecraft.tropical_fish": "ʻo iʻa iʻa",
  "item.minecraft.pufferfish": "ākēkē",
  "item.minecraft.cooked_cod": "kāpena kuke",
  "item.minecraft.cooked_salmon": "moʻa kāmano",
  "item.minecraft.ink_sac": "inika eke",
  "item.minecraft.red_dye": "kele ula",
  "item.minecraft.green_dye": "ʻo ka'ōmole kala",
  "item.minecraft.cocoa_beans": "ʻo ka pīniʻu koko",
  "item.minecraft.lapis_lazuli": "polū pohaku",
  "item.minecraft.purple_dye": "lila poni",
  "item.minecraft.cyan_dye": "waihoʻoluʻu cyan",
  "item.minecraft.light_gray_dye": "pohina hinahina māmā",
  "item.minecraft.gray_dye": "pale hina",
  "item.minecraft.pink_dye": "lau ʻulaʻula",
  "item.minecraft.lime_dye": "ka waihoʻoluʻu ʻōmaʻomaʻo",
  "item.minecraft.yellow_dye": "ka pulu uliula",
  "item.minecraft.light_blue_dye": "pale uila uila",
  "item.minecraft.magenta_dye": "lila poni",
  "item.minecraft.orange_dye": "ʻālani waihoʻoluʻu",
  "item.minecraft.bone_meal": "iwi pauka",
  "item.minecraft.blue_dye": "'okole blue",
  "item.minecraft.brown_dye": "keʻala",
  "item.minecraft.black_dye": "ʻo kaʻeleʻeleʻeleʻele",
  "item.minecraft.white_dye": "pāleka dye",
  "item.minecraft.bone": "iwi",
  "item.minecraft.sugar": "kōpaʻa",
  "block.minecraft.cake": "mea ʻono",
  "block.minecraft.white_bed": "ʻo ka'āpana kala",
  "block.minecraft.orange_bed": "ʻālani waihoʻoluʻu",
  "block.minecraft.magenta_bed": "ka moena magenta",
  "block.minecraft.light_blue_bed": "malamalama polū hulu hipa",
  "block.minecraft.yellow_bed": "ke moe moe",
  "block.minecraft.lime_bed": "moe ʻōmaʻomaʻo",
  "block.minecraft.pink_bed": "moe ākala",
  "block.minecraft.gray_bed": "moe hina",
  "block.minecraft.light_gray_bed": "moe hinahina māmā",
  "block.minecraft.cyan_bed": "kuhukukū moe",
  "block.minecraft.purple_bed": "moe lila",
  "block.minecraft.blue_bed": "moe kahuna",
  "block.minecraft.brown_bed": "moe kope",
  "block.minecraft.green_bed": "moe ʻōmaʻomaʻo",
  "block.minecraft.red_bed": "moe ʻulaʻula",
  "block.minecraft.black_bed": "moe ʻeleʻele",
  "item.minecraft.cookie": "mea ʻono",
  "item.minecraft.filled_map": "palapalaʻāina□#0",
  "item.minecraft.shears": "ʻūpā",
  "item.minecraft.melon_slice": "ka melon",
  "item.minecraft.dried_kelp": "kelp maloʻo",
  "item.minecraft.pumpkin_seeds": "palaʻai ʻanoʻano",
  "item.minecraft.melon_seeds": "ipu ʻanoʻano",
  "item.minecraft.beef": "ʻiʻo pipi maka",
  "item.minecraft.cooked_beef": "ʻiʻo pipi",
  "item.minecraft.chicken": "ʻiʻo moa maka",
  "item.minecraft.cooked_chicken": "ʻiʻo moa moʻa",
  "item.minecraft.rotten_flesh": "ʻiʻo pilau",
  "item.minecraft.ender_pearl": "enekela momi",
  "item.minecraft.blaze_rod": "lālā pale",
  "item.minecraft.ghast_tear": "ʻo ka haʻalulu",
  "item.minecraft.gold_nugget": "puʻupuʻu kula",
  "item.minecraft.nether_wart": "nekele ʻilikona",
  "item.minecraft.potion": "uncraftable potion□no effects",
  "item.minecraft.glass_bottle": "aniani ʻōmole",
  "item.minecraft.spider_eye": "hāwelewele",
  "item.minecraft.fermented_spider_eye": "nānā i ka maka honua",
  "item.minecraft.blaze_powder": "ka lū lū",
  "item.minecraft.magma_cream": "kalima pele",
  "block.minecraft.brewing_stand": "kūleʻa",
  "block.minecraft.cauldron": "ipu hao",
  "item.minecraft.ender_eye": "ka maka o ke kuʻi",
  "item.minecraft.glistering_melon_slice": "me ka'āpana melon",
  "item.minecraft.bat_spawn_egg": "ʻo ka huaʻo spa spawn",
  "item.minecraft.bee_spawn_egg": "ʻo ka bee spawn egg",
  "item.minecraft.blaze_spawn_egg": "ʻo ka huaʻo spa spawn",
  "item.minecraft.cat_spawn_egg": "ʻo cat spawn egg",
  "item.minecraft.cave_spider_spawn_egg": "ka hale kikooho spawn egg",
  "item.minecraft.chicken_spawn_egg": "kaʻi aloha spawn egg",
  "item.minecraft.cod_spawn_egg": "ʻo ka huaʻo spa spawn",
  "item.minecraft.cow_spawn_egg": "ʻo ka huaʻo spa spawn",
  "item.minecraft.creeper_spawn_egg": "ka hale kikooho spawn egg",
  "item.minecraft.dolphin_spawn_egg": "hoʻopukaʻia ka iʻa i ka iʻa",
  "item.minecraft.donkey_spawn_egg": "hoʻopukaʻia ka iʻa i ka iʻa",
  "item.minecraft.drowned_spawn_egg": "hoʻopukaʻia ka iʻa i ka iʻa",
  "item.minecraft.elder_guardian_spawn_egg": "ua pale ka kahu kahiko i ka hua",
  "item.minecraft.enderman_spawn_egg": "hoʻomanaʻia kahi hua iʻa",
  "item.minecraft.endermite_spawn_egg": "hoʻomanaʻia kahi hua iʻa",
  "item.minecraft.evoker_spawn_egg": "hoʻopukaʻia ka iʻa i ka iʻa",
  "item.minecraft.fox_spawn_egg": "fox spawn egg",
  "item.minecraft.ghast_spawn_egg": "ʻo ka huaʻo spa spawn",
  "item.minecraft.guardian_spawn_egg": "ua pale ka kahu kahiko i ka hua",
  "item.minecraft.hoglin_spawn_egg": "hua hoʻokumu hokalina",
  "item.minecraft.horse_spawn_egg": "hoʻopukaʻia ka iʻa i ka iʻa",
  "item.minecraft.husk_spawn_egg": "hoʻopukaʻia ka iʻa i ka iʻa",
  "item.minecraft.llama_spawn_egg": "ʻo ka huaʻo spa spawn",
  "item.minecraft.magma_cube_spawn_egg": "ka pelemaka cube spawn egg",
  "item.minecraft.mooshroom_spawn_egg": "ʻo nā mea hoʻolāʻauʻo mozas egg",
  "item.minecraft.mule_spawn_egg": "hoʻopukaʻia ka iʻa i ka iʻa",
  "item.minecraft.ocelot_spawn_egg": "'ohua manawale",
  "item.minecraft.panda_spawn_egg": "pea kina spawn egg",
  "item.minecraft.parrot_spawn_egg": "'ohua manawale",
  "item.minecraft.phantom_spawn_egg": "'ohua manawale",
  "item.minecraft.pig_spawn_egg": "ʻo ka huaʻo spa spawn",
  "item.minecraft.piglin_spawn_egg": "hua hoʻokumu pikalina",
  "item.minecraft.pillager_spawn_egg": "pillager spawn egg",
  "item.minecraft.polar_bear_spawn_egg": "ke polar bear spawn egg",
  "item.minecraft.pufferfish_spawn_egg": "ke kōkoʻa pale egg",
  "item.minecraft.rabbit_spawn_egg": "'ohua manawale",
  "item.minecraft.ravager_spawn_egg": "ravager spawn egg",
  "item.minecraft.salmon_spawn_egg": "'ohua manawale",
  "item.minecraft.sheep_spawn_egg": "ka hale kikooho spawn egg",
  "item.minecraft.shulker_spawn_egg": "hoʻopukaʻia ka iʻa i ka iʻa",
  "item.minecraft.silverfish_spawn_egg": "ke kōkoʻa pale egg",
  "item.minecraft.skeleton_spawn_egg": "'ohua manawale",
  "item.minecraft.skeleton_horse_spawn_egg": "'ohua manawale",
  "item.minecraft.slime_spawn_egg": "ʻo ka huaʻo spa spawn",
  "item.minecraft.spider_spawn_egg": "hua hoʻokumu strider",
  "item.minecraft.squid_spawn_egg": "hua hoʻokumu strider",
  "item.minecraft.stray_spawn_egg": "hua hoʻokumu strider",
  "item.minecraft.strider_spawn_egg": "hua hoʻokumu strider",
  "item.minecraft.trader_llama_spawn_egg": "mea kūʻai llama spawn egg",
  "item.minecraft.tropical_fish_spawn_egg": "pāhuna i’a ʻōpuʻu huamoa",
  "item.minecraft.turtle_spawn_egg": "honu hua manu",
  "item.minecraft.vex_spawn_egg": "ka hua manu hua ma vex",
  "item.minecraft.villager_spawn_egg": "villager spawn egg",
  "item.minecraft.vindicator_spawn_egg": "vindicator hua manu",
  "item.minecraft.wandering_trader_spawn_egg": "wandering trader spawn egg",
  "item.minecraft.witch_spawn_egg": "witch hua manu",
  "item.minecraft.wither_skeleton_spawn_egg": "wither skeleton hua manu",
  "item.minecraft.wolf_spawn_egg": "wolf hua manu",
  "item.minecraft.zoglin_spawn_egg": "hua hoʻokumu zokalina",
  "item.minecraft.zombie_spawn_egg": "zombie hua manu",
  "item.minecraft.zombie_horse_spawn_egg": "zombie horse hua manu",
  "item.minecraft.zombie_villager_spawn_egg": "zombie villager hua manu",
  "item.minecraft.zombified_piglin_spawn_egg": "hua hoʻokumu pikalina i hoʻomake ʻia",
  "item.minecraft.experience_bottle": "ʻōmole hoʻokalakupua",
  "item.minecraft.fire_charge": "pōpōahi",
  "item.minecraft.writable_book": "puke a kuilima",
  "item.minecraft.written_book": "buke kakau",
  "item.minecraft.emerald": "ʻemelala",
  "item.minecraft.item_frame": "pākuʻi huahana",
  "block.minecraft.flower_pot": "poho mea kanu",
  "item.minecraft.carrot": "kāloke",
  "item.minecraft.potato": "ʻuala kahiki",
  "item.minecraft.baked_potato": "ʻuala kahiki kālua",
  "item.minecraft.poisonous_potato": "uala ʻino",
  "item.minecraft.map": "palapalaʻāina hakahaka",
  "item.minecraft.golden_carrot": "kāloke kula",
  "block.minecraft.skeleton_skull": "iwi kanaka poʻo",
  "block.minecraft.wither_skeleton_skull": "iwi wikela kanaka poʻo",
  "block.minecraft.player_head": "kāpena honua",
  "block.minecraft.zombie_head": "huakaʻi po poʻo",
  "block.minecraft.creeper_head": "kelepela poʻo",
  "block.minecraft.dragon_head": "moʻo poʻo",
  "item.minecraft.carrot_on_a_stick": "carrot on a stick",
  "item.minecraft.warped_fungus_on_a_stick": "kūkaelio pupule ma ka lāʻau",
  "item.minecraft.nether_star": "nekela hoku",
  "item.minecraft.pumpkin_pie": "ʻamokiʻi",
  "item.minecraft.firework_rocket": "pōhaku ahi",
  "item.minecraft.firework_star": "hoku ahi",
  "item.minecraft.enchanted_book": "puke hoʻokalakupua",
  "item.minecraft.nether_brick": "nekele lepo",
  "item.minecraft.quartz": "nekele pohaku aʻiaʻi",
  "item.minecraft.tnt_minecart": "nā kāleka me tnt",
  "item.minecraft.hopper_minecart": "nā kāleka me hopper",
  "item.minecraft.prismarine_shard": "pelikimalina pohaku",
  "item.minecraft.prismarine_crystals": "pelikimalina aʻiaʻi",
  "item.minecraft.rabbit": "ʻiole lāpaki maka",
  "item.minecraft.cooked_rabbit": "ʻiole lāpaki moʻa",
  "item.minecraft.rabbit_stew": "ʻiole lāpaki kū",
  "item.minecraft.rabbit_foot": "wāwae o ka lāpaki",
  "item.minecraft.rabbit_hide": "hūnā lāpaki",
  "item.minecraft.armor_stand": "ʻaʻahu kaua pākaukau",
  "item.minecraft.iron_horse_armor": "hao lio ʻaʻahu kaua",
  "item.minecraft.golden_horse_armor": "kula lio ʻaʻahu kaua",
  "item.minecraft.diamond_horse_armor": "kaimana lio ʻaʻahu kaua",
  "item.minecraft.leather_horse_armor": "ka lole horse armor",
  "item.minecraft.lead": "kaula paʻa lima",
  "item.minecraft.name_tag": "inoa mekala",
  "item.minecraft.command_block_minecart": "minecart me ka poloka kauoha",
  "item.minecraft.mutton": "ʻiʻo hipa maka",
  "item.minecraft.cooked_mutton": "ʻiʻo hipa moʻa",
  "block.minecraft.white_banner": "white banner",
  "block.minecraft.orange_banner": "orange banner",
  "block.minecraft.magenta_banner": "magenta banner",
  "block.minecraft.light_blue_banner": "light blue banner",
  "block.minecraft.yellow_banner": "yellow banner",
  "block.minecraft.lime_banner": "lime banner",
  "block.minecraft.pink_banner": "pink banner",
  "block.minecraft.gray_banner": "gray banner",
  "block.minecraft.light_gray_banner": "light gray banner",
  "block.minecraft.cyan_banner": "cyan banner",
  "block.minecraft.purple_banner": "purple banner",
  "block.minecraft.blue_banner": "blue banner",
  "block.minecraft.brown_banner": "brown banner",
  "block.minecraft.green_banner": "green banner",
  "block.minecraft.red_banner": "red banner",
  "block.minecraft.black_banner": "black banner",
  "item.minecraft.end_crystal": "enekela aʻiaʻi",
  "item.minecraft.chorus_fruit": "hui hua",
  "item.minecraft.popped_chorus_fruit": "ʻo pepe chorus huina",
  "item.minecraft.beetroot": "pika",
  "item.minecraft.beetroot_seeds": "ʻo pepe chorus huina",
  "item.minecraft.beetroot_soup": "ʻeke beetroot",
  "item.minecraft.dragon_breath": "hanu deragona",
  "item.minecraft.splash_potion": "splash uncraftable potion□no effects",
  "item.minecraft.spectral_arrow": "ʻena pua pana",
  "item.minecraft.tipped_arrow": "uncraftable tipped arrow□no effects",
  "item.minecraft.lingering_potion": "lingering uncraftable potion□no effects",
  "item.minecraft.shield": "shield",
  "item.minecraft.elytra": "elytra",
  "item.minecraft.spruce_boat": "paina lāʻau moku",
  "item.minecraft.birch_boat": "keʻokeʻo lāʻau moku",
  "item.minecraft.jungle_boat": "wao nahele lāʻau moku",
  "item.minecraft.acacia_boat": "ʻakakiʻa lāʻau moku",
  "item.minecraft.dark_oak_boat": "pouli ʻoke lāʻau moku",
  "item.minecraft.totem_of_undying": "totem o ka make ʻole ʻana",
  "item.minecraft.shulker_shell": "pūpū shulker",
  "item.minecraft.iron_nugget": "pūliki hao",
  "item.minecraft.knowledge_book": "puke ʻike",
  "item.minecraft.debug_stick": "laau hoʻoiho",
  "item.minecraft.music_disc_13": "pā hoʻokani□c418 - 13",
  "item.minecraft.music_disc_cat": "pā hoʻokani□c418 - cat",
  "item.minecraft.music_disc_blocks": "pā hoʻokani□c418 - blocks",
  "item.minecraft.music_disc_chirp": "pā hoʻokani□c418 - chirp",
  "item.minecraft.music_disc_far": "pā hoʻokani□c418 - far",
  "item.minecraft.music_disc_mall": "pā hoʻokani□c418 - mall",
  "item.minecraft.music_disc_mellohi": "pā hoʻokani□c418 - mellohi",
  "item.minecraft.music_disc_stal": "pā hoʻokani□c418 - stal",
  "item.minecraft.music_disc_strad": "pā hoʻokani□c418 - strad",
  "item.minecraft.music_disc_ward": "pā hoʻokani□c418 - ward",
  "item.minecraft.music_disc_11": "pā hoʻokani□c418 - 11",
  "item.minecraft.music_disc_wait": "pā hoʻokani□c418 - wait",
  "item.minecraft.music_disc_pigstep": "pā hoʻokani□lena raine - pigstep",
  "item.minecraft.trident": "ke kuhi□□ke paʻa lima:□+8 attack damage□-2.9 attack speed",
  "item.minecraft.phantom_membrane": "membrane phantom",
  "item.minecraft.nautilus_shell": "kaheilus hauʻoli",
  "item.minecraft.heart_of_the_sea": "puʻuwai o ke kai",
  "item.minecraft.crossbow": "crossbow",
  "item.minecraft.suspicious_stew": "ʻo ke kai",
  "block.minecraft.loom": "loom",
  "item.minecraft.flower_banner_pattern": "pākuʻi banner□uku pua",
  "item.minecraft.creeper_banner_pattern": "hōʻike banner□ʻo ka uku kolo",
  "item.minecraft.skull_banner_pattern": "hōʻike banner□uku poʻo",
  "item.minecraft.mojang_banner_pattern": "hōʻike banner□mea",
  "item.minecraft.globe_banner_pattern": "hōʻike banner□poʻo honua",
  "item.minecraft.piglin_banner_pattern": "hōʻike banner□nuku",
  "block.minecraft.composter": "mea kīpulu",
  "block.minecraft.barrel": "ʻo barrel",
  "block.minecraft.smoker": "pumekala",
  "block.minecraft.blast_furnace": "ka makani heʻe",
  "block.minecraft.cartography_table": "papa papa kinohi",
  "block.minecraft.fletching_table": "ʻo ka papaʻaina",
  "block.minecraft.grindstone": "ʻo grindstone",
  "block.minecraft.lectern": "lectern",
  "block.minecraft.smithing_table": "ka papa hana hana",
  "block.minecraft.stonecutter": "kopaʻu",
  "block.minecraft.bell": "bell",
  "block.minecraft.lantern": "lantern",
  "block.minecraft.soul_lantern": "lama ʻuhane",
  "item.minecraft.sweet_berries": "nā huaʻala ʻono",
  "block.minecraft.campfire": "ʻo ke ahi",
  "block.minecraft.soul_campfire": "luaahi ʻuhane",
  "block.minecraft.shroomlight": "ao kūkaelio",
  "item.minecraft.honeycomb": "waihona meli",
  "block.minecraft.bee_nest": "piʻi manu",
  "block.minecraft.beehive": "hale pi",
  "item.minecraft.honey_bottle": "ʻōmole meli",
  "block.minecraft.honey_block": "meli palaka",
  "block.minecraft.honeycomb_block": "waihona meli palaka",
  "block.minecraft.lodestone": "pōhaku mākēneki",
  "block.minecraft.netherite_block": "palaka mekalanekele",
  "block.minecraft.ancient_debris": "koena kahiko",
  "block.minecraft.target": "māka",
  "block.minecraft.crying_obsidian": "mākā uē",
  "block.minecraft.blackstone": "pōhaku ʻeleʻele",
  "block.minecraft.blackstone_slab": "paukū pālālā pōhaku ʻeleʻele",
  "block.minecraft.blackstone_stairs": "ʻanuʻu pōhaku ʻeleʻele",
  "block.minecraft.gilded_blackstone": "pōhaku ʻeleʻele i poʻipū kula ʻia",
  "block.minecraft.polished_blackstone": "pōhaku ʻeleʻele hinua",
  "block.minecraft.polished_blackstone_slab": "paukū pālālā pōhaku ʻeleʻele hinua",
  "block.minecraft.polished_blackstone_stairs": "ʻanuʻu pōhaku ʻeleʻele hinua",
  "block.minecraft.chiseled_polished_blackstone": "pōhaku ʻeleʻele hinua i kila ʻia",
  "block.minecraft.polished_blackstone_bricks": "pōhaku lepo ʻeleʻele hinua",
  "block.minecraft.polished_blackstone_brick_slab": "paukū pālālā pōhaku lepo ʻeleʻele hinua",
  "block.minecraft.polished_blackstone_brick_stairs": "ʻanuʻu pōhaku ʻeleʻele hinua",
  "block.minecraft.cracked_polished_blackstone_bricks": "pōhaku lepo ʻeleʻele hinua i kīkē ʻia",
  "block.minecraft.respawn_anchor": "heleuma hoʻi",
}
export const haw_us = items; 
